import { color } from "@funded-here-interface/common";
import { MantineTheme, createStyles } from "@mantine/core";

export const useStyle = createStyles((theme: MantineTheme) => ({
  view: {
    color: color.FHADMIN,
    cursor: "pointer",
  },
}));
